var map = {
	"./addgs.svg": "Y95a",
	"./arrows-bdown.svg": "tpOz",
	"./arrowsdown.svg": "IC9F",
	"./arrowsup.svg": "ssSi",
	"./arrrows-pup.svg": "6ak/",
	"./auth.svg": "YbHB",
	"./barcode.svg": "vxWv",
	"./beallsoldout.svg": "jzKz",
	"./bestdw.svg": "GIGz",
	"./bluearrows.svg": "QT1r",
	"./dc.svg": "zY2Z",
	"./dizhi.svg": "Wf5N",
	"./duwnarrows.svg": "eBPU",
	"./edit.svg": "ql+d",
	"./editor.svg": "Fc7P",
	"./fault.svg": "ILZP",
	"./finance.svg": "pTuU",
	"./gift.svg": "UndF",
	"./guzhang.svg": "n8rG",
	"./help.svg": "35H+",
	"./hideeye.svg": "yphB",
	"./hint.svg": "W5el",
	"./home.svg": "U9Ws",
	"./horn.svg": "Pvyu",
	"./itemaddhint.svg": "BtLF",
	"./itemaddsushint.svg": "wuzn",
	"./link.svg": "KgwQ",
	"./loginuser.svg": "kZvo",
	"./machineMall.svg": "m2Ec",
	"./malfunction.svg": "i1Bx",
	"./more.svg": "gZ6Q",
	"./omit.svg": "nrFB",
	"./operation.svg": "Dh6m",
	"./organization.svg": "Jost",
	"./paycenter.svg": "VEPN",
	"./phone.svg": "7pRf",
	"./pwd.svg": "S6oQ",
	"./redarrows.svg": "dGjR",
	"./role-alter.svg": "VrWJ",
	"./role-delete.svg": "6R4s",
	"./role-down.svg": "VMbA",
	"./role-up.svg": "eJKS",
	"./role.svg": "cqqK",
	"./safe.svg": "1Bju",
	"./search.svg": "Bx0U",
	"./shop.svg": "hert",
	"./showeye.svg": "NexQ",
	"./skipblue.svg": "ebVp",
	"./skipgrey.svg": "JGUp",
	"./smalldw-b.svg": "PBTL",
	"./smalldw-r.svg": "Ocw3",
	"./stats.svg": "7jOc",
	"./status-h.svg": "0/53",
	"./stock.svg": "t+aG",
	"./success.svg": "C5yd",
	"./tax.svg": "eisL",
	"./tips.svg": "D4Qx",
	"./trash.svg": "9CsS",
	"./uparrows.svg": "AqNM",
	"./user.svg": "VdD3",
	"./warn.svg": "a5SC",
	"./wmmp.svg": "1yqL",
	"./wx.svg": "TcIh",
	"./yellowarrows.svg": "+gZI",
	"./zfb.svg": "T9eF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 127